import { supabase } from './supabase'

export interface AuditLogEntry {
  action: string
  resource_type: string
  resource_id?: string
  client_id?: string
  details?: Record<string, unknown>
}

export async function logAudit(entry: AuditLogEntry): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    // Using type assertion to bypass strict typing for insert
    const { error } = await supabase.from('audit_log').insert({
      user_id: user?.id || null,
      action: entry.action,
      resource_type: entry.resource_type,
      resource_id: entry.resource_id || null,
      client_id: entry.client_id || null,
      details: entry.details as any || null,
      ip_address: null,
      user_agent: navigator.userAgent,
    } as any)
    
    if (error) {
      console.error('Failed to log audit entry:', error)
    }
  } catch (error) {
    console.error('Failed to log audit entry:', error)
  }
}
